export const shortText = (value: string, maxLen = 8): string => {
  if (!value) return '';
  if (value.length <= maxLen + 3) return value;

  return `${value.slice(0, maxLen)}...${value.slice(-3)}`;
};

export function capitalize(str: string): string {
  if (!str) {
    return str;
  }
  const prunedStr = str.split('_').join(' ')
  return prunedStr.charAt(0).toUpperCase() + prunedStr.slice(1).toLowerCase();
}
